import ecRecommendationActions, {
    ecCycleClosingActions,
    ecModalRecommendationActions,
} from '../../consts/aws/ecRecommendationActions';
import helpers from '../../utils/helpers';
import ecPushRegistry from './ecPushRegistry';

const recommendationActions = [...Object.values(ecRecommendationActions), ...ecModalRecommendationActions];

let openCycles = {};

const isRecommendationAction = (action) => recommendationActions.includes(action);

const isClosingAction = (action) => ecCycleClosingActions.includes(action);

const openCycle = (recommendationType) => {
    const ecTriggerMessageId = ecPushRegistry.resolve(recommendationType);

    return {
        ecCycleId: helpers.guid(),
        ...(ecTriggerMessageId && {ecTriggerMessageId}),
    };
};

const resolve = (recommendationType, action) => {
    if (!recommendationType || !isRecommendationAction(action)) return {};

    const cycle = openCycles[recommendationType] || openCycle(recommendationType);

    openCycles[recommendationType] = cycle;

    if (isClosingAction(action)) {
        delete openCycles[recommendationType];

        ecPushRegistry.close(recommendationType);
    }

    return cycle;
};

const reset = () => {
    openCycles = {};
};

export default {
    isRecommendationAction,
    resolve,
    reset,
};
